function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useMemo, useRef, useState } from 'react';
import { createArray, getDocument, isAssigned, isNumber } from '@okee-uikit/react-utils';
import { useRefCallback, useSelectionMultiple, useSelectionSingle } from '@okee-uikit/react-hooks';
import { useCEP, useLocale } from '@okee-uikit/react-config';
import { Down, DownOne, UpOne } from '../../../common/icons';
import { Button } from '../../button';
import { Popover } from '../../popover';
import { Radio } from '../../radio';
import { Checkbox } from '../../checkbox';
import { getAllIdsRecursively, isAllDisabledRecursively, isAllSelectedRecursively, useTableRows } from '../row-data/row-info';
import { useTableSelection } from '../row-data/selection';
import { Filter } from './icons';
export var TableActiveTrigger = function TableActiveTrigger(props) {
  var _useCEP = useCEP('TableActiveTrigger'),
      comp = _useCEP.comp,
      elem = _useCEP.elem;

  var active = props.active,
      toggle = props.toggle,
      children = props.children;
  var onClick = useRefCallback(function (e) {
    e.stopPropagation();
    toggle(e);
  });
  return React.createElement("button", {
    className: comp({
      active: active
    }),
    onClick: onClick,
    role: "button"
  }, children !== null && children !== void 0 ? children : React.createElement(DownOne, {
    className: elem('Icon'),
    theme: "filled"
  }));
};
export var TableActiveIndent = function TableActiveIndent(props) {
  var _useCEP2 = useCEP('TableActiveIndent'),
      comp = _useCEP2.comp;

  var level = props.level,
      indent = props.indent;

  if (level === 1) {
    return null;
  }

  var width;

  if (isNumber(indent)) {
    if (indent === 0) {
      return null;
    }

    width = "".concat(indent, "px");
  } else {
    if (Number.parseInt(indent, 10) === 0) {
      return null;
    }

    width = indent;
  }

  var style = width !== 'mono' && {
    width: width
  } || undefined;
  return React.createElement("span", {
    className: comp(),
    "aria-hidden": true
  }, createArray(level - 1, function (i) {
    return React.createElement("i", {
      key: i,
      style: style
    });
  }));
};
export var TableSelectionHeader = function TableSelectionHeader(props) {
  var _props$type = props.type,
      type = _props$type === void 0 ? 'single' : _props$type,
      component = props.component,
      _props$dropdownMenu = props.dropdownMenu,
      dropdownMenu = _props$dropdownMenu === void 0 ? false : _props$dropdownMenu;

  var _useLocale = useLocale('table'),
      _useLocale$selectionM = _useLocale.selectionMenu,
      selectCurrent = _useLocale$selectionM.selectCurrent,
      selectAll = _useLocale$selectionM.selectAll,
      unselectCurrent = _useLocale$selectionM.unselectCurrent,
      unselectAll = _useLocale$selectionM.unselectAll;

  var _useCEP3 = useCEP('TableSelectionHeader'),
      comp = _useCEP3.comp,
      elem = _useCEP3.elem;

  var _useCEP4 = useCEP('TableSelectionMenu'),
      menuComp = _useCEP4.comp,
      menuElem = _useCEP4.elem;

  var _useTableRows = useTableRows(),
      original = _useTableRows.original,
      current = _useTableRows.current;

  var _useTableSelection = useTableSelection(),
      selected = _useTableSelection.selected,
      actions = _useTableSelection.actions;

  return useMemo(function () {
    if (!selected || !actions) {
      return null;
    }

    if (type === 'single' || component === 'switch') {
      return null;
    }

    var multipleSelected = selected;
    var multipleActions = actions;
    var allCurrent = getAllIdsRecursively(current);
    var allOriginal = getAllIdsRecursively(original);
    var allCurrentDisabled = isAllDisabledRecursively(current);
    var allCurrentSelected = isAllSelectedRecursively(current, allCurrentDisabled);
    var indeterminate = !allCurrentSelected && multipleSelected.length > 0;

    var onSelectAll = function onSelectAll(e) {
      var _a;

      multipleActions.select(allOriginal, e);
      (_a = props.onSelectAll) === null || _a === void 0 ? void 0 : _a.call(props, e);
    };

    var onUnselectAll = function onUnselectAll(e) {
      var _a;

      multipleActions.unselect(allOriginal, e);
      (_a = props.onUnselectAll) === null || _a === void 0 ? void 0 : _a.call(props, e);
    };

    var onSelectAllCurrent = function onSelectAllCurrent(e) {
      var _a;

      multipleActions.select(allCurrent, e);
      (_a = props.onSelectAllCurrent) === null || _a === void 0 ? void 0 : _a.call(props, e);
    };

    var onUnselectAllCurrent = function onUnselectAllCurrent(e) {
      var _a;

      multipleActions.unselect(allCurrent, e);
      (_a = props.onUnselectAllCurrent) === null || _a === void 0 ? void 0 : _a.call(props, e);
    };

    var content = React.createElement(Checkbox, {
      disabled: allCurrentDisabled,
      key: "check",
      className: elem('Checker'),
      checked: allCurrentSelected,
      indeterminate: indeterminate,
      onClick: allCurrentSelected ? onUnselectAllCurrent : onSelectAllCurrent
    });
    var menu;

    if (dropdownMenu) {
      var elemItem = menuElem('Item');
      menu = React.createElement(Popover, {
        key: "menu",
        className: elem('Trigger'),
        trigger: "hover",
        placement: "bottom-start",
        hideToDestroy: true,
        getPopper: function getPopper() {
          return React.createElement("div", {
            className: menuComp()
          }, React.createElement("button", {
            className: elemItem,
            onClick: onSelectAllCurrent
          }, selectCurrent), React.createElement("button", {
            className: elemItem,
            onClick: onSelectAll
          }, selectAll), React.createElement("button", {
            className: elemItem,
            onClick: onUnselectAllCurrent
          }, unselectCurrent), React.createElement("button", {
            className: elemItem,
            onClick: onUnselectAll
          }, unselectAll));
        }
      }, React.createElement(Down, {
        className: elem('TriggerIcon')
      }));
    }

    return React.createElement("div", {
      className: comp()
    }, content, menu);
  }, [type, component, dropdownMenu, current, original, selected, actions]);
};
export var TableFilterTrigger = function TableFilterTrigger(props) {
  var _useCEP5 = useCEP('TableQueryTrigger'),
      comp = _useCEP5.comp,
      elem = _useCEP5.elem;

  var _useCEP6 = useCEP('TableFilterPanel'),
      panelComp = _useCEP6.comp,
      panelElem = _useCEP6.elem;

  var id = props.id,
      _props$columnFilterOp = props.columnFilterOptions,
      type = _props$columnFilterOp.type,
      data = _props$columnFilterOp.data,
      state = props.state,
      actions = props.actions;
  var value = state[id];
  var hasValue = isAssigned(value);

  var _useSelectionSingle = useSelectionSingle(),
      _useSelectionSingle2 = _slicedToArray(_useSelectionSingle, 2),
      single = _useSelectionSingle2[0],
      singleActions = _useSelectionSingle2[1];

  var _useSelectionMultiple = useSelectionMultiple(),
      _useSelectionMultiple2 = _slicedToArray(_useSelectionMultiple, 2),
      multiple = _useSelectionMultiple2[0],
      multipleActions = _useSelectionMultiple2[1];

  var panelRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var onInit = useRefCallback(function (e) {
    setVisible(true);

    switch (type) {
      case 'single':
        singleActions.setValue(value);
        break;

      case 'multiple':
        multipleActions.setValue(value || []);
        break;
    }
  });
  var onCancel = useRefCallback(function (e) {
    if (!visible) {
      return;
    }

    setVisible(false);
    singleActions.setValue(undefined);
    multipleActions.setValue([]);
  });
  var onConfirm = useRefCallback(function (e) {
    if (!visible) {
      return;
    }

    setVisible(false);

    switch (type) {
      case 'single':
        actions.setPartial(_defineProperty({}, id, single));
        break;

      case 'multiple':
        actions.setPartial(_defineProperty({}, id, multiple.length && multiple || undefined));
        break;
    }
  });
  var resetAble = type === 'single' ? isAssigned(single) : type === 'multiple' ? multiple.length > 0 : false;
  var onReset = useRefCallback(function (e) {
    singleActions.setValue(undefined);
    multipleActions.setValue([]);
  });
  var onTriggerClick = useRefCallback(function (e) {
    var panelElem = panelRef.current;

    if (e && panelElem) {
      var target = e.target;

      if (panelElem === target || (panelElem === null || panelElem === void 0 ? void 0 : panelElem.contains(target))) {
        return;
      }
    }

    visible ? onCancel(e) : onInit(e);
  });
  var resetText = useLocale('table.filter.reset');
  var confirmText = useLocale('table.filter.confirm');

  var popper = function popper() {
    var elemItem = panelElem('Item');
    var nodes = [];

    switch (type) {
      case 'single':
        nodes = data.map(function (_ref) {
          var label = _ref.label,
              value = _ref.value,
              _ref$id = _ref.id,
              id = _ref$id === void 0 ? value : _ref$id;
          return React.createElement(Radio, {
            key: id,
            className: elemItem,
            size: "sm",
            checked: singleActions.isSelected(value),
            onChange: function onChange(e) {
              return singleActions.toggle(value, e);
            }
          }, label);
        });
        break;

      case 'multiple':
        nodes = data.map(function (_ref2) {
          var label = _ref2.label,
              value = _ref2.value,
              _ref2$id = _ref2.id,
              id = _ref2$id === void 0 ? value : _ref2$id;
          return React.createElement(Checkbox, {
            key: id,
            className: elemItem,
            checked: multipleActions.isSelected(value),
            onChange: function onChange(e) {
              return multipleActions.toggle(value, e);
            }
          }, label);
        });
        break;
    }

    return React.createElement("div", {
      ref: panelRef,
      className: panelComp()
    }, React.createElement("div", {
      className: panelElem('Body')
    }, nodes), React.createElement("div", {
      className: panelElem('Footer')
    }, React.createElement(Button, {
      type: "white",
      size: "xs",
      disabled: !resetAble,
      onClick: onReset
    }, resetText), React.createElement(Button, {
      type: "primary",
      size: "xs",
      onClick: onConfirm
    }, confirmText)));
  };

  useEffect(function () {
    var doc = getDocument();

    if (doc) {
      var onClickOutside = function onClickOutside(event) {
        var panelElem = panelRef.current;
        var target = event.target;

        if (!panelElem || panelElem === target || panelElem.contains(target)) {
          return;
        }

        onCancel(undefined);
      };

      doc.addEventListener('mousedown', onClickOutside);
      doc.addEventListener('touchstart', onClickOutside);
      return function () {
        doc.removeEventListener('mousedown', onClickOutside);
        doc.removeEventListener('touchstart', onClickOutside);
      };
    }
  }, []);
  return React.createElement("button", {
    className: comp({
      active: hasValue
    }),
    onClick: onTriggerClick,
    role: "button"
  }, React.createElement(Popover, {
    trigger: "manual",
    show: visible,
    getPopper: popper
  }, React.createElement(Filter, {
    className: elem('Filter')
  })));
};
export var TableSortTrigger = function TableSortTrigger(props) {
  var _a;

  var _useCEP7 = useCEP('TableQueryTrigger'),
      comp = _useCEP7.comp,
      elem = _useCEP7.elem;

  var id = props.id,
      state = props.state,
      actions = props.actions;
  var order = (_a = state.find(function (s) {
    return s.column === id;
  })) === null || _a === void 0 ? void 0 : _a.order;
  var onClick = useRefCallback(function (e) {
    return actions.switchOrder(id, e);
  });
  return React.createElement("button", {
    className: comp(),
    onClick: onClick,
    role: "button"
  }, React.createElement(UpOne, {
    key: "up",
    theme: "filled",
    className: elem('Up', {
      active: order === 'ascend'
    })
  }), React.createElement(DownOne, {
    key: "down",
    theme: "filled",
    className: elem('Down', {
      active: order === 'descend'
    })
  }));
};
export var TableColumnResizeTrigger = function TableColumnResizeTrigger(props) {
  var _useCEP8 = useCEP('TableColumnResizeTrigger'),
      comp = _useCEP8.comp;

  var onMouseDown = props.onMouseDown;
  return React.createElement("div", {
    className: comp(),
    onMouseDown: onMouseDown
  });
};